export const COST_CONFIG = {
  ide: {
    creditToUSD: 1, // 1 credit = $0.75
  },
  web: {
    inputCostPerMillion: 9, // $9 per million tokens
    outputCostPerMillion: 45, // $45 per million tokens
    creditToUSD: 1, // 1 credit = $0.75 (same as IDE)
  }
};

// Helper functions to convert between costs and credits
export const convertIDECostToCredits = (costInUSD: number): number => {
  return costInUSD / COST_CONFIG.ide.creditToUSD;
};

export const calculateWebCredits = (inputTokens: number, outputTokens: number): number => {
  const inputCost = (inputTokens / 1_000_000) * COST_CONFIG.web.inputCostPerMillion;
  const outputCost = (outputTokens / 1_000_000) * COST_CONFIG.web.outputCostPerMillion;
  return (inputCost + outputCost) / COST_CONFIG.web.creditToUSD;
};
